import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class ProtectedPowerSwitchesAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normIout = 15;
		this.normViMin = 1;
		this.normViMax = 5.5;

		this.rankIout = 0;
		this.rankViMin = 0;
		this.rankMax = 0;

		this.weightIout = 0.18;
		this.weightViMin = 0.16;
		this.weightViMax = 0.16;

		this.rIout = 0;
		this.rViMin = 0;
		this.rViMax = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log('partNumber,part_Iout,rIout,rankIout,part_ViMin,rViMin,rankViMin,part_ViMax,rViMax,rankViMax,feRank');
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Max Current iout (A)---------------------------------------------

		[this.rankIout, this.rIout] = this.calculateRankSingleSliderGTE(CIDS.I_OUT_MAX, product, this.normIout);

		// ---------------------------------------------Input voltage min (V)---------------------------------------------

		[this.rankViMin, this.rViMin] = this.calculateRankSingleSliderLTE(CIDS.V_IN_MIN, product, this.normViMin);

		// ---------------------------------------------Input voltage max (V)---------------------------------------------

		[this.rankViMax, this.rViMax] = this.calculateRankSingleSliderGTE(CIDS.V_IN_MAX, product, this.normViMax);

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightIout * this.rankIout + this.weightViMin * this.rankViMin + this.weightViMax * this.rankViMax;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightIout - this.weightViMin - this.weightViMax) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
